import React from "react";
import { Link } from "react-router-dom";
import { FaApple, FaEnvelope } from "react-icons/fa";

const AppleContact = () => {
  // Override the body overflow on mount to allow scrolling
  React.useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "auto";
    
    return () => {
      document.body.style.overflow = originalOverflow || "hidden";
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#f5f5f7] flex flex-col items-center justify-center p-4 sm:p-6 text-[#1d1d1f] font-sans">
      <div className="max-w-3xl w-full bg-white rounded-3xl shadow-xl overflow-hidden my-8">
        <div className="bg-[#1d1d1f] p-8 sm:p-10 flex flex-col items-center text-center">
          <FaApple size={60} className="text-white mb-4" />
          <h1 className="text-3xl sm:text-4xl font-semibold text-white tracking-tight leading-tight">Apple Developer Support</h1>
          <p className="text-[#a1a1a6] mt-3 text-base sm:text-lg">Contact details for application review and inquiries</p>
        </div>
        
        <div className="p-6 sm:p-10 space-y-8">
          <div className="flex flex-col sm:flex-row items-center sm:items-start text-center sm:text-left space-y-4 sm:space-y-0 sm:space-x-6 group">
            <div className="bg-[#f5f5f7] p-4 rounded-full group-hover:bg-[#0071e3] group-hover:text-white transition-colors duration-300 shrink-0">
              <FaEnvelope size={24} className="text-[#1d1d1f] group-hover:text-white transition-colors duration-300" />
            </div>
            <div className="break-words w-full">
              <h3 className="text-xl font-medium text-[#1d1d1f]">Email Support</h3>
              <p className="text-[#86868b] mt-1 text-sm sm:text-base">For general inquiries and app review feedback</p>
              <a href="mailto:mirceamartinioan@gmail.com" className="text-[#0071e3] font-medium hover:underline mt-2 inline-block break-all">mirceamartinioan@gmail.com</a>
            </div>
          </div>
        </div>
        
        <div className="bg-[#f5f5f7] p-6 text-center border-t border-[#e5e5ea]">
          <Link to="/" className="text-[#0071e3] font-medium hover:underline flex items-center justify-center space-x-2">
            <span>&larr;</span>
            <span>Back to Main Portfolio</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AppleContact;
